import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { cn } from "@/lib/utils";
import { PERMISSIONS } from "@/permissions/constant";
import { getUserPermissions, hasPermission } from "@/permissions/rbac";

/**
 * The candidate's name, linked to candidate analysis for the run's own
 * application. Plain text when the link cannot land: a run with no recorded
 * owner has no job to open, and a viewer without candidate.view would meet
 * the route's Unauthorized page.
 */
const CandidateNameLink = ({ candidate, className }) => {
  const { user } = useAuth();
  const { candidateName, candidateId, owningJobId } = candidate ?? {};
  const canOpen = candidateId && owningJobId && hasPermission(PERMISSIONS.CANDIDATE_VIEW, getUserPermissions(user));

  if (!canOpen) return <div className={className}>{candidateName}</div>;

  return (
    <Link to={`/admin/candidate-analysis/${candidateId}?job_id=${owningJobId}`} className={cn("hover:underline", className)}>
      {candidateName}
    </Link>
  );
};

export default CandidateNameLink;
